import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Play } from 'lucide-react';
import VideoPlayerModal from '../shared/VideoPlayerModal';
import { trackVideoClick } from '../../utils/trackVideoClick';

const EngagementVideoCard = ({ item, position, onOpen }) => {
  const { t } = useTranslation();
  const [isPlaying, setIsPlaying] = useState(false);

  const handleOpen = () => {
    trackVideoClick({ title: item.title, carousel: 'featured' });
    if (typeof onOpen === 'function') {
      onOpen(item, position);
    }
    setIsPlaying(true);
  };

  const handleClose = () => setIsPlaying(false);

  if (!item) return null;

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        aria-label={t('engagement_carousel.play_video', 'Play {{title}}', {
          title: item.title,
        })}
        className="
          group flex-shrink-0 text-left
          w-[240px] sm:w-[260px] md:w-[280px]
          rounded-xl border border-gray-200 bg-white overflow-hidden
          hover:border-gray-300 hover:shadow-md
          active:scale-[0.98]
          transition-all duration-200
          focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2
        "
      >
        <div className="relative aspect-video bg-gray-100">
          <img
            src={item.thumbnailUrl}
            alt=""
            loading="lazy"
            className="
              w-full h-full object-cover
              transition-transform duration-300
              group-hover:scale-[1.03]
            "
          />

          <div
            className="
              absolute inset-0 flex items-center justify-center
              bg-gradient-to-t from-black/40 via-black/10 to-transparent
              transition-opacity
            "
            aria-hidden="true"
          >
            <span
              className="
                w-12 h-12 rounded-full bg-white/95
                flex items-center justify-center
                shadow-lg
                transition-transform duration-200
                group-hover:scale-110 group-hover:bg-white
              "
            >
              <Play
                className="w-5 h-5 text-gray-900 ml-0.5"
                aria-hidden="true"
                fill="currentColor"
              />
            </span>
          </div>

          {item.duration ? (
            <div
              className="
                absolute bottom-2 right-2
                bg-black/70 text-white text-[11px] font-medium
                px-1.5 py-0.5 rounded
              "
            >
              {item.duration}
            </div>
          ) : null}
        </div>

        <div className="p-3">
          <h4 className="text-sm font-semibold text-gray-900 leading-snug line-clamp-2 min-h-[2.5rem]">
            {item.title}
          </h4>
          {item.source ? (
            <p className="text-xs text-gray-500 mt-1.5 truncate">
              {item.source}
            </p>
          ) : null}
        </div>
      </button>

      {isPlaying ? (
        <VideoPlayerModal
          video={{ id: item.videoId, title: item.title }}
          onClose={handleClose}
        />
      ) : null}
    </>
  );
};

export default EngagementVideoCard;
